// Campus photo for /colleges/university-of-massachusetts-lowell: CC BY-SA 3.0, by Ktr101, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACoburn_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-massachusetts-lowell/; credited under the photo.
const photo = {
    "slug": "university-of-massachusetts-lowell",
    "alt": "Coburn Hall, a stone building with arched windows and twin chimneys behind a tree-lined lawn, on the South Campus of the University of Massachusetts Lowell",
    "src": "/colleges/university-of-massachusetts-lowell/campus-1600.webp",
    "srcSmall": "/colleges/university-of-massachusetts-lowell/campus-800.webp",
    "srcMid": "/colleges/university-of-massachusetts-lowell/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-massachusetts-lowell/og.jpg",
    "title": "Coburn Hall",
    "author": "Ktr101",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACoburn_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
